<script setup>
import { computed } from 'vue';
import { useKeyboardEvents } from 'dashboard/composables/useKeyboardEvents';
import wootConstants from 'dashboard/constants/globals';

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  activeTab: {
    type: String,
    default: wootConstants.ASSIGNEE_TYPE.ME,
  },
});

const emit = defineEmits(['chatTabChange']);

const activeTabIndex = computed(() => {
  return props.items.findIndex(item => item.key === props.activeTab);
});

const onTabChange = selectedTabIndex => {
  if (selectedTabIndex >= 0 && selectedTabIndex < props.items.length) {
    const selectedItem = props.items[selectedTabIndex];
    if (selectedItem.key !== props.activeTab) {
      emit('chatTabChange', selectedItem.key);
    }
  }
};

const keyboardEvents = {
  'Alt+KeyN': {
    action: () => {
      if (props.activeTab === wootConstants.ASSIGNEE_TYPE.ALL) {
        onTabChange(0);
      } else {
        const nextIndex = (activeTabIndex.value + 1) % props.items.length;
        onTabChange(nextIndex);
      }
    },
  },
};

useKeyboardEvents(keyboardEvents);
</script>

<template>
  <div class="flex items-center w-full gap-1 px-3 pt-1 pb-2">
    <button
      v-for="(item, index) in items"
      :key="item.key"
      class="inline-flex items-center flex-shrink-0 gap-1.5 h-8 px-3 rounded-lg text-xs font-medium transition-colors duration-150 min-w-0"
      :class="
        item.key === activeTab
          ? 'bg-n-slate-12 text-n-slate-1'
          : 'bg-n-slate-3 text-n-slate-11 hover:bg-n-slate-4'
      "
      @click="onTabChange(index)"
    >
      <span class="truncate">{{ item.name }}</span>
      <span
        class="inline-flex items-center justify-center h-4 min-w-4 px-1 rounded-full text-[11px] font-semibold flex-shrink-0"
        :class="
          item.key === activeTab
            ? 'bg-n-slate-1/25 text-n-slate-1'
            : 'bg-n-slate-5 text-n-slate-10'
        "
      >
        {{ item.count }}
      </span>
    </button>
  </div>
</template>
